export enum FeatureFlag {
  GROWTH_WEBSITE_BANNER = "GROWTH_WEBSITE_BANNER",
  WEB_SCHEDULING_DOUBLE_BOOKING_GUARD_ENABLED = "WEB_SCHEDULING_DOUBLE_BOOKING_GUARD_ENABLED",
  WEBSITE_SHOW_BOOK_BTN_ON_NAV = "WEBSITE_SHOW_BOOK_BTN_ON_NAV",
  WEB_SCHEDULING_ABANDONED_FLOW_ENABLED = "WEB_SCHEDULING_ABANDONED_FLOW_ENABLED",
}
